/*import {} from '@/components/views';*/

import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/charts/styles.css';

import { Chart as ChartJS, registerables } from 'chart.js';
import {
    Loader,
    LoadingOverlay,
    MantineProvider,
    createTheme,
    rem,
} from '@mantine/core';
import { useAuthStore, useSiteStore } from './store';
import { useEffect, useState } from 'react';

import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import { Notifications } from '@mantine/notifications';
import Routes from './Routes';
import { Signalr } from './components/common';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import tz from 'dayjs/plugin/timezone';
import useGetProfile from './http/mutations/auth/useGetProfile';
import { useLocalStorage } from '@mantine/hooks';
import zoomPlugin from 'chartjs-plugin-zoom';

const App = () => {
    dayjs.extend(tz);
    dayjs.extend(LocalizedFormat);
    dayjs.extend(customParseFormat);
    dayjs.tz.setDefault('America/New_York');

    ChartJS.register(...registerables, zoomPlugin);
    const [loading, setLoading] = useState(true);

    const authToken = useAuthStore((state) => state.authToken);
    const { mutate: getProfile } = useGetProfile();
    useEffect(() => {
        if (authToken == null) {
            setLoading(false);
            return;
        }
        setLoading(true);
        getProfile(null, {
            onSettled() {
                setLoading(false);
            },
        });
    }, [authToken]);

    const [colorScheme, setColorScheme] = useLocalStorage({
        key: 'mantine-color-scheme',
        defaultValue: 'dark',
        getInitialValueInEffect: true,
    });

    const theme = createTheme({
        fontSizes: {
            xs: '10px', // approximately 10px
            sm: '12px', // approximately 11.67px
            md: '14px', // approximately 13.33px
            lg: '16px', // approximately 15px
            xl: '18px', // approximately 16.67px
        },
    });

    const toggleColorScheme = (value) =>
        setColorScheme(value || (colorScheme === 'dark' ? 'light' : 'dark'));

    return (
        <MantineProvider
            theme={theme}
            defaultColorScheme='dark'>
            <LoadingOverlay visible={loading} />
            <Signalr>
                <Notifications
                    position='top-right'
                    zIndex={1000}
                />
                {!loading && <Routes />}
            </Signalr>
        </MantineProvider>
    );
};
export default App;
